import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axiosInstance from '../../api/axiosInstance';

const LoginForm: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const res = await axiosInstance.post('/api/auth/login', { username, password });
      localStorage.setItem('token', res.data.token);
      window.location.href = '/';
    } catch (err: any) {
      if (err.response && err.response.data && err.response.data.error) {
        setError(err.response.data.error);
      } else {
        setError('서버 통신 실패 또는 계정 정보 오류');
      }
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '60px auto 20px auto', padding: '36px', background: 'var(--surface)', borderRadius: 'var(--radius-md)', border: '1px solid var(--border)', boxShadow: 'var(--shadow-md)' }}>
      <h2 style={{ fontSize: 26, fontWeight: 800, textAlign: 'center', marginBottom: 24, letterSpacing: '-0.5px' }}>
        🔑 역사 아카이브 로그인
      </h2>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group" style={{ marginBottom: 16 }}>
          <label className="form-label">아이디</label>
          <input
            type="text"
            placeholder="아이디를 입력하세요"
            value={username}
            onChange={e => setUsername(e.target.value)}
            className="modern-input"
            required
          />
        </div>
        
        <div className="form-group" style={{ marginBottom: 24 }}>
          <label className="form-label">비밀번호</label>
          <div style={{ position: 'relative' }}>
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="비밀번호를 입력하세요"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="modern-input"
              style={{ paddingRight: '40px' }}
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: 'absolute',
                right: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0,
                color: 'var(--text-secondary, #666)'
              }}
              aria-label={showPassword ? '비밀번호 숨기기' : '비밀번호 보기'}
            >
              {showPassword ? (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              )}
            </button>
          </div>
        </div>
        
        <button type="submit" className="modern-btn modern-btn-primary" style={{ width: '100%', padding: '12px' }}>
          로그인
        </button>
        
        {error && (
          <div style={{ 
            color: 'var(--danger)', 
            backgroundColor: 'var(--danger-light)', 
            padding: '10px 14px', 
            borderRadius: 'var(--radius-sm)', 
            fontSize: 13, 
            fontWeight: 600,
            marginTop: 16,
            textAlign: 'center'
          }}>
            ⚠️ {error}
          </div>
        )}
      </form>
      
      <div style={{ marginTop: 24, textAlign: 'center', fontSize: 13.5, color: 'var(--text-secondary)' }}>
        계정이 없으신가요?{' '}
        <Link to="/register" style={{ color: 'var(--primary)', fontWeight: 700, textDecoration: 'underline' }}>
          회원가입 하기
        </Link>
      </div>
    </div>
  );
};

export default LoginForm;
